module.exports = __webpack_public_path__ + "static/media/Youtube.d556e636.svg";